module.exports = __webpack_public_path__ + "static/media/deadline.c1b48989.svg";